const initCategoriasCalendario = () => {
    const categoriasCalendario = document.querySelectorAll(".filtro-calendario-categoria");

    if (!categoriasCalendario) return;

    categoriasCalendario.forEach(categoria => {
        categoria.addEventListener("click", (e) => {
            const categoriaId = e.target.getAttribute("value");
            
            categoriasCalendario.forEach(cat => cat.classList.remove("active"));
            e.target.classList.toggle("active");
            
            if (categoriaId === "todas") {
                const todasClases = document.querySelectorAll(".row-clase");
                todasClases.forEach(clase => {
                    clase.style.display = "block";
                });
                return;
            }

            const clases = document.querySelectorAll(".row-clase");
            clases.forEach(clase => {
                const categoriaIds = categoriaId.split(",");
                const hasCategoria = categoriaIds.some(id => clase.classList.contains(`categoria-${id}`));
                if (hasCategoria) {
                    clase.style.display = "block";
                } else {
                    clase.style.display = "none";
                }
            });
        });
    });
}

export default initCategoriasCalendario;